// extracted by mini-css-extract-plugin
export default {"chargeText":"AddTeamMembersModal_chargeText__qh9E4"};